import * as React from 'react';
import clsx from 'clsx';
import { Modal } from '@/components/ui/Modal';
import { useUiStore } from '@/store/uiStore';

export const SupportModal: React.FC = () => {
  const isOpen = useUiStore((state) => state.modals.support);
  const closeModal = useUiStore((state) => state.closeModal);

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => closeModal('support')}
      className='border-0'
      style={{
        width: '388px',
        maxWidth: '100%',
        background:
          'linear-gradient(180deg, rgba(255, 255, 255, 0) -1.92%, #A28DF6 140.84%), #FFFFFF',
      }}
    >
      <div className='flex flex-col items-center pt-2 text-center'>
        {/* Header */}
        <h2 className='mb-2 font-proxima text-24 font-bold text-brand-800'>Help & Support</h2>

        {/* Subtitle */}
        <p className='mb-8 font-sans text-16 font-normal leading-21 text-gray-600'>
          Tell us what you need
          <br />
          and we’ll assist.
        </p>

        {/* Support Container */}
        <div
          className={clsx(
            'flex items-center justify-center',
            'h-[49px] w-[227px]',
            'rounded-[30px]',
            'bg-gray-100/50'
          )}
        >
          <a
            href='mailto:support@dechoai.com'
            className={clsx(
              'font-sans text-16 font-bold leading-21 tracking-normal',
              'text-gray-600',
              'hover:underline'
            )}
          >
            support@dechoai.com
          </a>
        </div>
      </div>
    </Modal>
  );
};
